// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';

/**
 * Get segments configuration from s-segments attribute
 * Returns an array of segment/condition blocks or null
 */
const getConditionalSegments = (selector: string): unknown => {
  const template = getTemplateIframeDocument();
  const element: HTMLElement | null = template?.querySelector(selector);

  if (element) {
    const attr = element.getAttribute('s-segments');
    if (!attr) return null;

    try {
      return JSON.parse(attr);
    } catch (error) {
      console.error('Error parsing s-segments:', error);
      return null;
    }
  }

  return null;
};

export default getConditionalSegments;
